<template>
    <footer>
        <div>
            <router-link :to="{ name: 'home' }" width="100" aria-label="home">
                <img src="/images/header/PIP-WestChester-Logo.svg" width="300" alt="PIP West Chester logo">
            </router-link>
        </div>
        <div class="footer-links-container row">
            <div class="col-md-3 mt-3">
                <p class="heading">RESOURCES</p>
                <ul class="links">
                    <li>
                        <router-link :to="{ path: '/brands' }"
                            >Brand</router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'company' }">Company</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'literature' }">Product Catalogs</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'privacy' }"
                            >Privacy Policy</router-link
                        >
                    </li>
                    <li><a href="https://pipglobalsafety.com/sustainability" target="_blank" aria-label='Link opens in new window (pipglobalsafety.com/sustainability)'>Sustainability</a></li>
                </ul>
            </div>

            <div class="social col-md-3 mt-3">
                <p class="heading d-block">CONNECT WITH US</p>
                <a
                    href="https://www.facebook.com/WestChesterGear/"
                    target="blank"
                    aria-label='Link opens in new window (facebook.com/WestChesterGear)'
                    ><i class="fab fa-facebook fa-2x p-1"></i
                ></a>
                <a href="https://www.twitter.com/westchestergear" target="blank" class="social-link"
                    aria-label='Link opens in new window (twitter.com/westchestergear)'
                    ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"/></svg>
                </a>
                <a
                    href="https://www.instagram.com/westchestergear/"
                    target="blank"
                    aria-label='Link opens in new window (instagram.com/westchestergear)'
                    ><i class="fab fa-instagram-square fa-2x p-1"></i
                ></a>
                <a
                    href="https://www.youtube.com/westchestergloves"
                    target="blank"
                    aria-label='Link opens in new window (youtube.com/westchestergloves)'
                    ><i class="fab fa-youtube-square fa-2x p-1"></i
                ></a>
                <a
                    href="https://www.linkedin.com/company/west-chester-holdings"
                    target="blank"
                    aria-label='Link opens in new window (linkedin.com/company/west-chester-holdings)'
                    ><i class="fab fa-linkedin fa-2x p-1"></i
                ></a>
            </div>
            <div class="contact col-md-3 mt-3">
                <div class="phone">
                    <p class="heading">call us today:</p>
                    <p class="number">
                        <a href="tel:5188610133">(513) 705-2100</a>
                    </p>
                </div>
                <div class="phone">
                    <p class="heading">customer service direct</p>
                    <p class="number">
                        <a href="tel:8552846800">(800) 969-7562</a>
                    </p>
                </div>
            </div>
            <div class="location col-md-3 mt-3">
                <div class="address">
                    <p class="heading">Cincinnati, OH</p>
                    <p class="address">
                        11500 Canal Road<br />Cincinnati, OH 45241
                    </p>
                </div>
                <!-- <div class="address">
                    <p class="heading">global headquarters</p>
                    <p class="address">
                        25 British American Blvd.<br />Latham, NY 12110
                    </p>
                </div> -->
            </div>
        </div>
        <div class="row">
            <div class="col-sm-9">
                <p class="my-3 font-weight-light" style="font-size: .8rem;">
                    Copyright © West Chester Protective Gear 2010 -
                    {{ new Date().getFullYear() }}. All Rights Reserved.
                </p>
            </div>
            <div class="col-sm-3">
                <a href="https://pipglobal.com/" target="_blank" aria-label="Link opens in new window (pipglobal.com)">
                    <img src="/images/pip-global-safety-logo.svg" width="150" alt="PIP Global Safety Logo">
                </a>
            </div>
        </div>
        <cookie-law theme="pip" :buttonText="text">
            <div slot-scope="props" class="w-100 row p-2">
                <p class="col-9">
                    This site uses cookies to provide you with the best
                    experience possible. By continuing to use this website
                    without modifying your settings, you are consenting to our
                    use of cookies. Learn more and how to manage your settings.
                    <router-link to="/cookies" class="cookie-link"
                        >More Information</router-link
                    >
                </p>
                <button
                    @click="props.accept"
                    class="btn-round-white pt9rem col-3 pipButton"
                >
                    I Accept
                </button>
            </div>
        </cookie-law>
    </footer>
</template>

<script>
import CookieLaw from "vue-cookie-law";
export default {
    data() {
        return {
            text: "Accept Cookies"
        };
    },
    components: { CookieLaw }
};
</script>

<style lang="scss" scoped>
.Cookie--pip {
    background: #111;
    padding: 2rem;
    font-size: 0.9rem;
}

.pipButton {
    line-height: 1;
    max-height: 35px;
    max-width: 100px;
    margin-left: auto;
    font-size: 0.9rem;
}

a {
    color: white;
    font-weight: normal;
}

a.cookie-link {
    color: #01549e;
    margin-left: 0.5rem;
    &:hover {
        text-decoration: underline;
    }
}
</style>
